import Vue from "vue";

import { defineStore } from "pinia";
import { postData } from "@utils";
import { useToast } from "vue-toastification/composition";
import { ref, computed, nextTick } from "@vue/composition-api";

export const useRootStore = defineStore("root", () => {
  const toast = useToast();

  // Listeleme
  const listDisabled = ref(true);
  const tableLoading = ref(false);
  const tableItems = ref([]);
  const dialogLoading = ref(false);
  const editedIndex = ref(-1);
  const editedItem = ref({
    rootno: "",
    mattype: "",
    orderdays: [],
    openhour: "",
    closehour: "",
    addopenhour: "",
    addclosehour: "",
    orderdelivery: "",
    addorderdelivery: "",
    isactive: true,
  });

  const defaultItem = JSON.parse(JSON.stringify(editedItem.value));

  const tableFetch = async () => {
    listDisabled.value = true;
    tableLoading.value = true;
    try {
      const data = await postData({
        method: "adminRootDayList",
      });

      tableItems.value = data.response.result.map((item) => {
        return {
          id: item.id,
          mattype: item.mattype,
          rootno: item.rootno,
          orderdays: item.orderdays.split(",").map((item) => Number(item)),
          openhour: item.openhour.slice(0, 5),
          closehour: item.closehour.slice(0, 5),
          addopenhour: item.addopenhour.slice(0, 5),
          addclosehour: item.addclosehour.slice(0, 5),
          orderdelivery: item.orderdelivery,
          addorderdelivery: item.addorderdelivery,
          isactive: item.isactive,

        };
      });

      return [data, null];
    } catch (e) {
      // API hataya girdi
      toast.error(`Hata ${e}`);

      return [null, true];
    } finally {
      tableLoading.value = false;
      listDisabled.value = false;
    }
  };

  // Ekle / Düzenle / Sil
  const addEditdialog = ref(false);
  const deleteLoading = ref(false);
  const saveLoading = ref(false);
  const addEditFormTitle = computed(() => {
    return editedIndex.value === -1 ? "Root Ekle" : "Düzenleme";
  });

  const editItem = (item) => {
    editedIndex.value = tableItems.value.indexOf(item);
    editedItem.value = Object.assign({}, item);
    addEditdialog.value = true;
  };

  const saveItem = async (isValid) => {
    // Form Kontrol
    if (!isValid) {
      toast.error(`Lütfen kırımızı alanları doldurun`, { position: "bottom-center" });

      return;
    }
    dialogLoading.value = true;

    try {
      saveLoading.value = true;
      if (editedIndex.value > -1) {
        const response = await postData({
          method: "saveRootDays",
          id: editedItem.value.id,
          "field[rootno]": editedItem.value.rootno,
          "field[mattype]": editedItem.value.mattype,
          "field[orderdays]": editedItem.value.orderdays,
          "field[openhour]": editedItem.value.openhour,
          "field[closehour]": editedItem.value.closehour,
          "field[addopenhour]": editedItem.value.addopenhour,
          "field[addclosehour]": editedItem.value.addclosehour,
          "field[orderdelivery]": editedItem.value.orderdelivery,
          "field[addorderdelivery]": editedItem.value.addorderdelivery,
          "field[isactive]": editedItem.value.isactive,
        });
        if (response.error) {
          throw new Error(response.msg);
        }

        toast.info(`Root güncellendi`);
      } else {
        const response = await postData({
          method: "saveRootDays",
          "field[rootno]": editedItem.value.rootno,
          "field[mattype]": editedItem.value.mattype,
          "field[orderdays]": editedItem.value.orderdays,
          "field[openhour]": editedItem.value.openhour,
          "field[closehour]": editedItem.value.closehour,
          "field[addopenhour]": editedItem.value.addopenhour,
          "field[addclosehour]": editedItem.value.addclosehour,
          "field[orderdelivery]": editedItem.value.orderdelivery,
          "field[addorderdelivery]": editedItem.value.addorderdelivery,
          "field[isactive]": editedItem.value.isactive,
        });
        if (response.error) {
          throw new Error(response.msg);
        }

        toast.success(` Root eklendi`);
      }

      tableFetch();
    } catch (e) {
      toast.error(`Hata ${e}`, { position: "bottom-center" });
      return;
    } finally {
      closeItem();
    }
  };

  const deleteItem = async () => {
    Vue.swal({
      title: "Emin misin",
      html: `<strong>"${editedItem.value.rootno}"</strong><br>root silinsin mi`,
      icon: "warning",
      width: "350px",
      background: "#FF4C51",
      showCancelButton: true,
      confirmButtonColor: "#cc3d41",
      confirmButtonText: "Evet",
      cancelButtonText: "Vazgeç",
      cancelButtonColor: "#FF4C51",
    }).then(async (result) => {
      if (result.isConfirmed) {
        dialogLoading.value = true;
        deleteLoading.value = true;
        try {
          const response = await postData({
            method: "deleteRoot",
            id: editedItem.value.id,
          });
          if (response.error) {
            throw new Error(response.msg);
          }
          toast.warning(`"${editedItem.value.rootno}" root silindi`);
          tableFetch();
        } catch (e) {
          toast.error(`Hata ${e}`, { position: "bottom-center" });
        } finally {
          closeItem();
        }
      }
    });
  };

  const closeItem = () => {
    dialogLoading.value = false;
    deleteLoading.value = false;
    saveLoading.value = false;
    addEditdialog.value = false;
    editedItem.value = Object.assign({}, defaultItem);
    editedIndex.value = -1;
  };

  return {
    // Listeleme
    listDisabled,
    tableLoading,
    tableItems,
    tableFetch,
    editedItem,
    editedIndex,

    // Ürün Ekle / Düzenle / Sil
    dialogLoading,
    deleteLoading,
    saveLoading,
    addEditFormTitle,
    addEditdialog,
    editItem,
    deleteItem,
    closeItem,
    saveItem,
  };
});
